module.exports = __webpack_public_path__ + "img/company_icon2.62e5f21d.png";